const STANDARD_BINARY_MANAGERS = [
  "manager_llm_binary",
  "manager_audio_llm_judge",
  "manager_audio_llm_binary",
  "manager_words_per_message_with_threshold",
  "manager_transcript_regex_match",
]

const INVERTED_BINARY_MANAGERS = [
  "manager_agent_repeats_itself",
  "manager_agent_fails_to_respond",
  "manager_agent_needs_reprompting",
  "manager_user_frustration",
  "manager_agent_refusal",
  "manager_custom_agent_fails_to_respond",
  "manager_custom_agent_needs_reprompting",
]

const CONFIGURABLE_BINARY_MANAGERS = ["manager_custom_end_reason"]

export const BINARY_MANAGERS = [
  ...STANDARD_BINARY_MANAGERS,
  ...INVERTED_BINARY_MANAGERS,
  ...CONFIGURABLE_BINARY_MANAGERS,
]

export const isBinaryMetric = (metric: {
  metric_manager: string
  metric_name: string
  output_type?: string
}) => {
  // Python instances declare either a numeric scalar or a YES/NO string.
  if (metric.metric_manager === "manager_python") {
    return metric.output_type === "string"
  }
  if (BINARY_MANAGERS.includes(metric.metric_manager)) {
    return true
  }
  return (
    metric.metric_name.includes("llm_binary") ||
    metric.metric_name.includes("yesnoquestions") ||
    (metric.metric_name.includes("faster") &&
      !metric.metric_name.includes("similarity")) ||
    metric.metric_name.includes("check") ||
    metric.metric_name.includes("informationrevelation")
  )
}

export const isInvertedBinaryMetric = (metric: { metric_manager: string }) => {
  return INVERTED_BINARY_MANAGERS.includes(metric.metric_manager)
}
